var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTildeVerde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165636",
    "data-name": "Grupo 165636",
    transform: "translate(-16600.499 617.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164200",
    "data-name": "Grupo 164200",
    transform: "translate(16600 -618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_9633",
    "data-name": "Elipse 9633",
    transform: "translate(0.499 0.5)",
    fill: "none",
    stroke: "#0ecb00",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 36.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M40.23,9,16.7,36.325,6,23.9",
    transform: "translate(16615.604 -600.745)",
    fill: "none",
    stroke: "#0ecb00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildeVerde);
export default __webpack_public_path__ + "static/media/tilde-verde.f88bc9bd18d7c1a3b20868a1e51df03e.svg";
export { ForwardRef as ReactComponent };